var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconReorder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6774_16139)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.04187 0H12.5419C12.9286 0 13.2995 0.141448 13.5729 0.393225C13.8464 0.645003 14 0.986486 14 1.34255C14 1.69862 13.8464 2.0401 13.5729 2.29188C13.2995 2.54366 12.9286 2.68511 12.5419 2.68511H-2.04187C-2.42859 2.68511 -2.79947 2.54366 -3.07292 2.29188C-3.34638 2.0401 -3.5 1.69862 -3.5 1.34255C-3.5 0.986486 -3.34638 0.645003 -3.07292 0.393225C-2.79947 0.141448 -2.42859 0 -2.04187 0V0ZM-2.04187 6.04236H12.5419C12.7334 6.04236 12.923 6.07708 13.0999 6.14455C13.2768 6.21202 13.4375 6.31091 13.5729 6.43558C13.7083 6.56025 13.8157 6.70825 13.889 6.87113C13.9623 7.03402 14 7.2086 14 7.38491C14 7.56121 13.9623 7.7358 13.889 7.89868C13.8157 8.06157 13.7083 8.20957 13.5729 8.33424C13.4375 8.4589 13.2768 8.5578 13.0999 8.62527C12.923 8.69274 12.7334 8.72746 12.5419 8.72746H-2.04187C-2.42859 8.72746 -2.79947 8.58601 -3.07292 8.33424C-3.34638 8.08246 -3.5 7.74098 -3.5 7.38491C-3.5 7.02884 -3.34638 6.68736 -3.07292 6.43558C-2.79947 6.1838 -2.42859 6.04236 -2.04187 6.04236V6.04236ZM-2.04187 12.3149H12.5419C12.9286 12.3149 13.2995 12.4563 13.5729 12.7081C13.8464 12.9599 14 13.3014 14 13.6574C14 14.0135 13.8464 14.355 13.5729 14.6068C13.2995 14.8586 12.9286 15 12.5419 15H-2.04187C-2.42859 15 -2.79947 14.8586 -3.07292 14.6068C-3.34638 14.355 -3.5 14.0135 -3.5 13.6574C-3.5 13.3014 -3.34638 12.9599 -3.07292 12.7081C-2.79947 12.4563 -2.42859 12.3149 -2.04187 12.3149V12.3149Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6774_16139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconReorder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Reorder.b25d5ebf.svg";
export { ForwardRef as ReactComponent };